import { render, staticRenderFns } from "./setScoreRuleDialog.vue?vue&type=template&id=5bf2900e&"
import script from "./setScoreRuleDialog.vue?vue&type=script&lang=js&"
export * from "./setScoreRuleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports